import { createStore, getActionIds } from '../helpers/redux';
import Immutable from 'immutable';

import { AppActions } from '../actions/app';
import { ProjectActions } from '../actions/project';
import { ElementActions } from '../actions/element';
import { UserActions } from '../actions/user';
// import { TagActions } from '../actions/tag';
// import { CommentActions } from '../actions/comment';
// import { ImportActions } from '../actions/import';
// import { AuthActions } from '../actions/auth';

const appActions = getActionIds(AppActions);
const projectActions = getActionIds(ProjectActions);
const elementActions = getActionIds(ElementActions);
const userActions = getActionIds(UserActions);
// const tagActions = getActionIds(TagActions);
// const commentActions = getActionIds(CommentActions);
// const importActions = getActionIds(ImportActions);
// const authActions = getActionIds(AuthActions);

const initialState = Immutable.fromJS({
  notifications: {},
});

const addToNotificationsStateMap = (type, content, state) => {
  const notifications = state.get('notifications').toJS();
  return {
    ...notifications,
    [type]: [
        ...(notifications[type] || []),
      {
        message: content
      }
    ]
  }
}
export const app = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  '*': (state, action) => {
    if (action.type.endsWith('-FAILURE')) {
      return state.merge({
        notifications: addToNotificationsStateMap('error', action.error.json.errors || 'Failure!', state)
      })
    }
    return state;
  },

  [projectActions.createProject.success]: (state, action) => {
    return state.merge({
      notifications: addToNotificationsStateMap('success', 'Your project has been created successfully.', state)
    })
  },

  // [commentActions.commentLengthError]: (state, action) => {
  //   return state.merge({
  //     notifications: {
  //       error: [
  //         {
  //           message: 'Comment field must not be empty.',
  //         },
  //       ],
  //     },
  //   });
  // },

  [elementActions.createElement.success]: (state, action) => {
    return state.merge({
      notifications: addToNotificationsStateMap('error', 'Your element has been created successfully.', state)
    })
  },

  [appActions.setNotification]: (state, action) => {
    return state.merge({
      notifications: action.notification,
    });
  },

  [appActions.dismissNotices]: (state, action) => {
    if (typeof action.notificationIdx !== "undefined"){
      const notifications = state.get('notifications').toJS();

      const targetedNotificationsGroup = notifications[action.notificationType];
      targetedNotificationsGroup.splice(action.notificationIdx, 1);

      return state.merge({
        notifications: {
          ...notifications,
          [action.notificationType]: [...targetedNotificationsGroup]
        },
      });
    }
    return state;

  },

  // [tagActions.untagElement.failure]: (state, action) => {
  //   return state.merge({
  //     notifications: {
  //       error: [
  //         {
  //           message: 'An error occurred while deleting that tag.',
  //         },
  //       ],
  //     },
  //   });
  // },

  [userActions.addProjectUser.success]: (state, _action) => {
    return state.merge({
      notifications: addToNotificationsStateMap('success', 'An email has been sent to the new user.', state)
    })
  },

  [userActions.changePassword.success]: (state, _action) => {
    return state.merge({
      notifications: addToNotificationsStateMap('success', 'Your password has been changed.', state)
    })
  },

  [userActions.resetPassword.success]: (state, _action) => {
    return state.merge({
      notifications: addToNotificationsStateMap('success', 'Your password has been changed.', state)
    })
  },

  [userActions.resetPassword.failure]: (state, action) => {
    return state.merge({
      notifications: addToNotificationsStateMap('error', `Unable to reset password. ${action.error.json.error}`, state)
    })
  },

  [userActions.forgotPassword.failure]: (state, action) => {
    return state.merge({
      notifications: addToNotificationsStateMap('error', `${action.error.json.error}.`, state)
    })
  },

  [userActions.forgotPassword.success]: (state, action) => {
    return state.merge({
      notifications: addToNotificationsStateMap('success', 'An email will be sent to the address provided to reset your password.', state)
    })
  },

  [userActions.confirmEmail.success]: (state, _action) => {
    return state.merge({
      notifications: addToNotificationsStateMap('success', 'Your email address has been confirmed and updated successfully.', state)
    })
  },

  [userActions.confirmEmail.failure]: (state, _action) => {
    return state.merge({
      notifications: addToNotificationsStateMap('error', 'The confirmation hash provided is invalid.', state)
    })
  },

  [userActions.changeEmail.success]: (state, _action) => {
    return state.merge({
      notifications: addToNotificationsStateMap('success', 'We just sent you an email to confirm your new email address!', state)
    })
  },

  [userActions.updateProfile.success]: (state, _action) => {
    return state.merge({
      notifications: addToNotificationsStateMap('success', 'Your profile has been updated successfully.', state)
    })
  },
});

export const routingSelector = state => {
  const pathname = state.routing.locationBeforeTransitions.pathname;

  if (
    pathname.match(/^\/organizations\/[0-9]\/account+/) ||
    pathname.match(/^\/account/)
  ) {
    return 'account';
  }

  if (pathname.match(/^\/organizations/)) {
    return 'organization';
  }

  if (pathname.match(/^\/project\//)) {
    return 'project';
  }

  return 'project';
};



// WEBPACK FOOTER //
// ./src/reducers/app.js